module.exports = __webpack_public_path__ + "img/outgoing-green.520cf81d.svg";